import { emperor } from '~/services';

export const getMaintenanceMode = async (): Promise<boolean> => {
  const response = await emperor.get('/public/maintenance-mode', {
    headers: { skipAuthHeader: true }
  });
  return response.data.maintenance_mode as boolean;
};
